import { AppController } from "../AppController";
var ReviewPage = /** @class */ (function () {
    function ReviewPage(_appController) {
        this._appController = _appController;
    }
    Object.defineProperty(ReviewPage.prototype, "appController", {
        get: function () {
            return this._appController;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReviewPage.prototype, "organization", {
        get: function () {
            return this.appController.organization;
        },
        enumerable: true,
        configurable: true
    });
    ReviewPage.prototype.toLanguageName = function (languageCode) {
        var language = this.appController.availableLanguages.find(function (language) { return language.code === languageCode; });
        return (language ? language.name : languageCode);
    };
    ReviewPage.prototype.toCountryName = function (countryCode) {
        var country = this.appController.availableCountries.find(function (country) { return country.code === countryCode; });
        return (country ? country.name : countryCode);
    };
    ReviewPage.prototype.print = function () {
        var printData = document.getElementById("printableSection").innerHTML;
        var popupWin = window.open("", "_blank", "width=800,height=800");
        popupWin.document.open();
        popupWin.document.write("\n      <!doctype html>\n      <html>\n      <body style=\"font-family: sans-serif; font-size: 10pt; line-height: 130%\">\n        <img src=\"assets/sprplus_logo.gif\">\n        " + printData + "\n      </body>\n      </html>\n    ");
        popupWin.onload = function () { popupWin.print(); popupWin.close(); };
        popupWin.document.close();
    };
    return ReviewPage;
}());
export { ReviewPage };
